'use client';

import { useEffect } from 'react';

export const GTM_ID = process.env.NEXT_PUBLIC_DEFAULT_GOOGLE_TAG_MANAGER_ID;

export function GoogleTagManagerScript() {
  useEffect(() => {
    // Load GTM script after the main page content has loaded
    const loadGTM = setTimeout(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
      document.head.appendChild(script);
    }, 1000); // Delay script loading by 1 second

    return () => clearTimeout(loadGTM);
  }, []);

  return null;
}

export function GoogleTagManagerNoScript() {
  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
        id="gtmTag"
        title="Google Tag Manager"
      />
    </noscript>
  );
}
